import { browserPageHealthPreferencesRepository } from "./page-health-preferences.js";

const pageHealth = globalThis.__fishystuffPageHealth;
if (!pageHealth || typeof pageHealth.bindPreferencesRepository !== "function") {
  throw new Error("Page-health preference bootstrap requires the page-health service.");
}

pageHealth.bindPreferencesRepository(browserPageHealthPreferencesRepository());
